// sources for media
export default [
    'Free',
    'RT',
    'Gettyimages.ru',
    "Wikimedia.org",
]
